import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay"];

  connect() {
    this.hideOverlay();
    this.isSubmitting = false;
  }

  handleSubmit(event) {
    if (this.isSubmitting) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    this.isSubmitting = true;
    this.showOverlay();

    // Allow form to submit normally
    // Browser will wait synchronously for server response
    // Overlay will disappear when page redirects
    return true;
  }

  showOverlay() {
    const overlay = this.findOverlay();
    if (overlay) {
      overlay.classList.remove("hidden");
    }
  }

  hideOverlay() {
    const overlay = this.findOverlay();
    if (overlay) {
      overlay.classList.add("hidden");
    }
  }

  findOverlay() {
    if (this.hasOverlayTarget) {
      return this.overlayTarget;
    }

    // Fallback: search in document
    return document.getElementById("apply-diffs-loading-overlay");
  }

  disconnect() {
    this.isSubmitting = false;
    this.hideOverlay();
  }
}
